module.exports = __webpack_public_path__ + "img/icon-letter-m.da2e6a4d.svg";